import { ActiveFilterState } from 'src/app/models/active-filters.model';
import { FilterDetailType } from 'src/app/models/filter-detail-type.model';
import { CarAggregatedDetails } from 'src/app/models/railcar.model';
import { StccsOption } from 'src/app/models/stcc-option.model';

export const filterSelectionState: string = 'selections';

export const filterDetailObj: FilterDetailType = {
  capacity: {
    filterElements: {
      displayAs: 'range',
      field: 'capacity',
      rank: 1,
      carAttributeName: 'capacity',
      alwaysOpen: true,
    },
    detailElements: { field: 'capacity' },
  },
  'hatch-cover': {
    filterElements: {
      displayAs: 'checkbox',
      field: 'hatch-cover',
      rank: 2,
      carAttributeName: 'hatch_cover',
    },
    cardElements: { field: 'hatch_cover' },
  },
  length: {
    filterElements: {
      displayAs: 'checkbox',
      field: 'length',
      rank: 2,
      carAttributeName: 'length',
    },
    cardElements: { field: 'length' },
  },
  height: {
    filterElements: {
      displayAs: 'multiselect',
      field: 'height',
      rank: 2,
      carAttributeName: 'height',
    },
    cardElements: { field: 'height' },
  },
  status: {
    filterElements: {
      displayAs: 'checkbox',
      field: 'status',
      rank: 2,
      carAttributeName: 'status',
      alwaysOpen: true,
    },
    cardElements: { field: 'status' },
  },
  coupler_type: {
    filterElements: {
      displayAs: 'checkbox',
      field: 'coupler_type',
      rank: 2,
      carAttributeName: 'coupler_type',
    },
    cardElements: { field: 'coupler_type' },
  },
  'gate-type': {
    filterElements: {
      displayAs: 'checkbox',
      field: 'gate-type',
      rank: 3,
      carAttributeName: 'gate_type',
    },
    cardElements: { field: 'gate_type' },
  },
  'gate-size': {
    filterElements: {
      displayAs: 'checkbox',
      field: 'gate-size',
      rank: 4,
      carAttributeName: 'gate_size',
      displayWhen: {
        field: 'gate-type',
        carAttributeName: 'gate_type',
        value: ['Gravity', 'Gravity-Pneumatic'],
        isVisible: false,
      },
    },
    cardElements: { field: 'gate_size' },
  },
  'compartment-qty': {
    filterElements: {
      displayAs: 'checkbox',
      field: 'compartment-qty',
      rank: 5,
      carAttributeName: 'compartments',
    },
    cardElements: {
      field: 'compartments',
      title: 'Compartment Qty',
    },
  },
  'test-pressure': {
    filterElements: {
      displayAs: 'checkbox',
      field: 'test-pressure',
      rank: 6,
      carAttributeName: 'pressure',
    },
    cardElements: {
      field: 'pressure',
      valueTail: 'PSI',
    },
  },
  coils: {
    filterElements: {
      displayAs: 'checkbox',
      field: 'coils',
      rank: 7,
      carAttributeName: 'coils',
    },
    cardElements: { field: 'coils' },
  },
  insulation: {
    filterElements: {
      displayAs: 'checkbox',
      field: 'insulation',
      rank: 8,
      carAttributeName: 'insulation',
    },
    cardElements: { field: 'insulation' },
  },
  'stencil-spec': {
    filterElements: {
      displayAs: 'multiselect',
      field: 'stencil-spec',
      rank: 9,
      carAttributeName: 'stencil_spec',
    },
    cardElements: { field: 'stencil_spec' },
  },
  'gross-rail-load': {
    filterElements: {
      displayAs: 'checkbox',
      field: 'gross-rail-load',
      rank: 10,
      carAttributeName: 'gross_rail_load',
      labelTail: 'lbs',
    },
    cardElements: {
      field: 'gross_rail_load',
      labelTail: '(Lbs)',
    },
  },
  location: {
    filterElements: {
      displayAs: 'location',
      field: 'location',
      rank: 99,
      carAttributeName: 'country',
      carAttributeName2: 'state',
      alwaysOpen: true,
    },
  },
};

export const carDetailAttributeList = [
  'count',
  'gross_rail_load',
  'capacity_uom',
  'capacity',
  'gate_type',
  'gate_size',
  'hatch_cover',
  'compartments',
  'stencil_spec',
  'insulation',
  'coils',
  'pressure',
  'country',
  'state',
  'coupler_type',
  'length',
  'height',
] as (keyof CarAggregatedDetails)[];

export const OTHER: StccsOption = {
  stcc: 'Other',
  stcc_description: 'Other',
  description_stcc: 'Other',
  car_types: [],
  model_ids: [],
};

export const noCarsFoundMessage = {
  message:
    'We didn’t find railcar matches for you today. Try changing your filters, or Begin Quote Request without selecting railcars and your account manager will follow up with you soon.',
  header: 'Stay with us!',
  color: 'blue',
};

export const multiOptionsMessage = {
  message:
    'The product you entered may be carried in multiple railcar types. Please select railcar type to see results.',
  color: 'red',
};

export const defaultFilterState: ActiveFilterState = {
  coils: 'All',
  state: 'All',
  country: 'All',
  capacity: [0, 0],
  height: 'All',
  compartments: 'All',
  car_type: '',
  pressure: 'All',
  gate_size: 'All',
  gate_type: 'All',
  insulation: 'All',
  hatch_cover: 'All',
  coupler_type: 'All',
  length: 'All',
  capacity_uom: '',
  stencil_spec: 'All',
  gross_rail_load: 'All',
  description_stcc: '',
};
